/**
 * The creative-type choices a SCRIPT can be given, for the Creative Elements
 * step's per-script dropdown.
 *
 * These are the same four the session-level picker offers
 * (`services/creative_formats.py`, surfaced as `creative_type_options`), but
 * this step's dropdown is per script and is reached without a session read, so
 * the labels live here rather than being fetched again. The VALUES must stay
 * identical — a script typed `AI:COMFY` here and `AI` there would route two
 * different ways — and a backend test pins the two lists against each other.
 */
export const CREATIVE_TYPE_UI = [
  { value: "AI:TRELLO", label: "AI VIDEO TRELLO" },
  { value: "AI:COMFY", label: "AI VIDEO COMFY (DO NOT USE)" },
  { value: "VE", label: "VE (Video Editor)" },
  { value: "UGC", label: "UGC (Creator)" },
];
